import { render, staticRenderFns } from "./PersonEditForm.vue?vue&type=template&id=b170a36a&scoped=true&"
import script from "./PersonEditForm.vue?vue&type=script&lang=js&"
export * from "./PersonEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b170a36a",
  null
  
)

export default component.exports